import { useState, useEffect } from "react";

interface Props {
  name: string;
  license: string | null;
  phone: string | null;
  headshotUrl: string | null;
  loState?: string | null;
}

/**
 * Overlays drawn on top of the <video> element:
 *  - Top-left: floating LO badge with circular headshot + name
 *  - Bottom-left: lower-third with name • NMLS • phone
 */
export default function PlayerOverlay({ name, license, phone, headshotUrl, loState }: Props) {
  // Same broken-URL handling as Sidebar: if the headshot fails to load,
  // swap to the initials placeholder so we never render a broken <img>.
  const [photoFailed, setPhotoFailed] = useState(false);
  useEffect(() => { setPhotoFailed(false); }, [headshotUrl]);

  return (
    <>
      <div className="lo-badge" aria-hidden="true">
        {headshotUrl && !photoFailed ? (
          <img
            src={headshotUrl}
            alt=""
            className="lo-badge__photo"
            onError={() => setPhotoFailed(true)}
          />
        ) : (
          <div className="lo-badge__photo lo-badge__photo--placeholder">
            {name.charAt(0)}
          </div>
        )}
        <div className="lo-badge__text">
          <div className="lo-badge__name">{name}</div>
          {loState && <div className="lo-badge__sub">Loan Officer · {loState}</div>}
        </div>
      </div>

      <div className="lower-third" aria-hidden="true">
        <div className="lower-third__bar" />
        <div>
          <div className="lower-third__name">{name}</div>
          <div className="lower-third__meta">
            {license && <span>NMLS #{license}</span>}
            {license && phone && <span className="lower-third__sep" />}
            {phone && <span>{phone}</span>}
          </div>
        </div>
      </div>
    </>
  );
}
